module.exports = __webpack_public_path__ + "img/armor-gloves.f4d4acfe.svg";